import React, { Component } from "react";
import PropTypes from "prop-types";

export default class List extends Component {
  renderLoadMore() {
    const { isFetching } = this.props;
    return <div>{isFetching ? "Loading..." : "Load More"}</div>;
  }

  render() {
    const {
      isFetching,
      nextPageUrl,
      pageCount,
      items,
      renderItem,
      loadingLabel,
    } = this.props;

    const isEmpty = items.length === 0;

    if (isEmpty && isFetching) {
      return <div>{loadingLabel}</div>;
    }

    const isLastPage = !nextPageUrl;
    if (isEmpty && isLastPage) {
      return <div>No results</div>;
    }

    return (
      <div>
        {items.map(renderItem)}
        {pageCount > 0 && !isLastPage && this.renderLoadMore()}
      </div>
    );
  }
}

List.propTypes = {
  loadingLabel: PropTypes.string.isRequired,
  pageCount: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  nextPageUrl: PropTypes.string,
};

List.defaultProps = {
  isFetching: true,
  loadingLabel: "Loading...",
};
